module.exports = __webpack_public_path__ + "assets/img/mail@2x.ff489365.png";